import React, { Dispatch } from 'react';
import { ReportFlowStep } from './index';

export enum ProfitAndLossPeriodType {
  BEGINNING_OF_YEAR = 'BEGINNING_OF_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  MONTHLY_REPORT = 'MONTHLY_REPORT',
  QUARTERLY_REPORT = 'QUARTERLY_REPORT',
  ALL_TIME = 'ALL_TIME',
  CUSTOM = 'CUSTOM',
}

export enum ReportOutputType {
  PDF = 'PDF',
  EXCEL = 'EXCEL',
}

export interface IProfitAndLossFilters {
  period?: {
    periodType?: string;
    startDate: Date;
    endDate: Date;
  };
  outputType: ReportOutputType;
}

export interface IProfitAndLossPeriod {
  title?: string;
  type: string;
}

interface IDateRange {
  startDate: Date | null;
  endDate: Date | null;
}

export interface IContext {
  isLoading: boolean;
  iframeUrlProfitAndLoss: string | undefined;
  IframeUrlCashFlow: string | undefined;
  iframeUrlExpenses: string | undefined;
  expensesFileName?: string;
  cashFlowFileName?: string;
  profitAndLossFileName?: string;
  activeStep: ReportFlowStep;
  setActiveStep: Dispatch<React.SetStateAction<any>>;
  setFilterObject: Dispatch<React.SetStateAction<any>>;
  filterObject: IProfitAndLossFilters;
  dateRange: IDateRange;
  setIsDatesRangeComplete: Dispatch<React.SetStateAction<any>>;
  setDateRange: Dispatch<React.SetStateAction<any>>;
  setReportType: Dispatch<React.SetStateAction<any>>;
  toggleData?: { incomeTrxCnt: number; expenseTrxCnt: number };
  iframeUrl?: string;
}
